import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import CustomTypography from '../Typography/CustomTypography';
import { type FC } from 'react';

interface CircularProgressProps {
  id: string;
  variant?: 'determinate' | 'indeterminate';
  color?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning';
  className?: string;
  disableShrink?: boolean; //Works only for indeterminate
  value?: number; //Works only for determinate
  size?: number; //Works for px
  isProgressWithLabel?: boolean;
}

const CustomCircularProgress: FC<CircularProgressProps> = ({
  id,
  className,
  variant = 'indeterminate',
  color = 'primary',
  disableShrink = false,
  value = 0,
  size,
  isProgressWithLabel = false,
  ...rest
}) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        id={id}
        variant={variant}
        color={color}
        disableShrink={disableShrink}
        value={value}
        className={className}
        size={size}
        {...rest}
      ></CircularProgress>
      {isProgressWithLabel && (
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CustomTypography
            id={`${id}-circular-progress`}
            variant="caption"
            color="textPrimary"
          >{`${Math.round(value)}%`}</CustomTypography>
        </Box>
      )}
    </Box>
  );
};

export default CustomCircularProgress;
